import { httpGet, httpPost } from 'src/utils/http';
import {
  TemplateGalleryAvailableCategoriesList,
  TemplateGalleryCampaignTemplatesListType,
  TemplateGalleryCampaignTemplatesRequestType,
  TemplateGalleryDetailsResponseType,
  TemplateGalleryMostUsedListType,
  AvailableCampaignTemplateCategoriesRequestType,
  GetFeaturedTemplatesRequestType,
} from 'src/models/Modals/templateGallery';

const getPath = (path: string) => `/OrganizerTemplate/${path}`;

export const apiLoadCampaignTemplateDetails = (id: string): Promise<TemplateGalleryDetailsResponseType> =>
  httpGet(getPath('LoadCampaignTemplateDetails'), { id });

export const apiGetMostUsedTemplates = (): Promise<TemplateGalleryMostUsedListType> =>
  httpGet(getPath('GetMostUsedTemplates'));

export const apiGetFeaturedTemplates = (
  data: GetFeaturedTemplatesRequestType
): Promise<TemplateGalleryMostUsedListType> => httpGet(getPath('GetFeaturedTemplates'), data);

export const apiGetAvailableCampaignTemplateCategories = (
  data: AvailableCampaignTemplateCategoriesRequestType
): Promise<TemplateGalleryAvailableCategoriesList> => httpGet(getPath('GetAvailableCampaignTemplateCategories'), data);

export const apiLoadCampaignTemplateList = (
  data: TemplateGalleryCampaignTemplatesRequestType
): Promise<TemplateGalleryCampaignTemplatesListType> => httpPost(getPath('LoadCampaignTemplateList'), data);
